import React, { useState, useEffect } from "react";
import { useFirebase } from "../../database/FirebaseContext";
import useSound from "use-sound";
import SoundFile from "./TaskCompletionAlert.mp3";

                                     
function EditSprintTask({ closeModal, task, colourBlindMode }) {
    const { editSprintTask,getAllUsersData } = useFirebase();
    const [userList,setUserList] = useState([])
    const [editableSprintTask, setEditableSprintTask] = useState(task);
    const [sprintCurrLogTime, setSprintCurrLogTime] = useState(0);
    const getPriorityBackgroundColor = (colourBlindMode, priority) => {
        if (colourBlindMode === true) {
            switch (priority) {
                case 1:
                    return "accent-[#A2E365]";
                case 2:
                    return "accent-[#F3F38B]";
                case 3:
                    return "accent-[#D27D23]";
                default:
                    return "accent-[#C96514]";
            }
        }
        else {
            switch (priority) {
                case 1:
                    return "accent-[#00FF19]";
                case 2:
                    return "accent-[#DDFF0A]";
                case 3:
                    return "accent-[#FA632D]";
                default:
                    return "accent-[#ff3528]";
            }
        }
      };

    const [playSound] = useSound(SoundFile);

    useEffect(() => {
        const { elements } = document.querySelector("form");

        for (const [key, value] of Object.entries(editableSprintTask)) {
            const field = elements.namedItem(key);
            field && (field.value = value);
        }
        const getUserList = async ()=>{
            const rawUserList = await getAllUsersData()
            const nameList = rawUserList.map((user)=>{
              return user.userName
            })
            setUserList(nameList)
            
          }
          getUserList()
    }, []);

    const handleSprintLogTimeChange = (event) => {
        const { name, value } = event.target;
        setSprintCurrLogTime(value);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name !== "sprintLogTime") {
            setEditableSprintTask((values) => ({ ...values, [name]: value }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (editableSprintTask.taskStatus === "Completed") {
            playSound();
        }

        const totalLogTimeSpent =
            editableSprintTask.sprintLogTime.reduce((accum, logTime) => {
                return accum + logTime.hour;
            }, 0) + parseInt(sprintCurrLogTime);

        const data = {
            ...editableSprintTask,
            taskPriority: parseInt(editableSprintTask.taskPriority),
            sprintLogTime: [
                ...editableSprintTask.sprintLogTime,
                {
                    day: editableSprintTask.sprintStartDate,
                    hour: parseInt(sprintCurrLogTime),
                },
            ],
            sprintTotalLogTime: totalLogTimeSpent,
            sprintCompletionDate: editableSprintTask.taskStatus === "Completed" ? editableSprintTask.sprintStartDate : "",
        };
        editSprintTask(task.id, data);
    };

    return (
        <div className="block fixed z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] left-0 top-0">
            {/* modal content */}
            <div className="flex justify-center items-center mt-[12%] ml-[30%] w-[1250px]">
                {/* title */}
                <div className="text-[#ffffff] w-5/12 h-auto bg-[#3D3E44] rounded-xl">
                    {/* Header for Form */}
                    <div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
                        Edit Sprint Task
                    </div>
                    {/* Form Body */}
                    <div className="bg-[#3D3E44] rounded-b-xl">
                        <form onSubmit={handleSubmit}>
                            <div>
                                {/* Task Name */}
                                <div className="bg-modalbg flex mt-[20px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[55px]">
                                        <label for="taskName">
                                            <p className="text-[14px]">Name</p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
                                        <input
                                            type="text"
                                            id="taskName"
                                            name="taskName"
                                            value={
                                                editableSprintTask.taskName ||
                                                ""
                                            }
                                            onChange={handleChange}
                                            required
                                            className="pl-[5px] text-[13px] bg-fieldbg w-full bg-[#616675] rounded"
                                        />
                                    </div>
                                </div>

                                {/* Type */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[63px]">
                                        <label for="taskType">
                                            <p className="text-[14px]">Type</p>
                                        </label>
                                    </div>

                                    <div className="bg-modalbg flex shrink-10 items-center mr-[10px] space-x-[10px]">
                                        <div className="flex items-center space-x-[3px]">
                                            <input
                                                type="radio"
                                                id="bugType"
                                                name="taskType"
                                                value="Bug"
                                                onChange={handleChange}
                                                required
                                            />
                                            <label for="bugType">
                                                <p className="text-[13px] pt-[1px]">
                                                    Bug
                                                </p>
                                            </label>
                                        </div>
                                        <div className="flex items-center space-x-[3px]">
                                            <input
                                                type="radio"
                                                id="defaultType"
                                                name="taskType"
                                                value="Default Story"
                                                onChange={handleChange}
                                                required
                                            />
                                            <label for="defaultType">
                                                <p className="text-[13px] pt-[1px]">
                                                    Default
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Story Point */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[24px]">
                                        <p className="text-[14px]">
                                            Story Point
                                        </p>
                                    </div>

                                    <div className="bg-fieldbg flex shrink-10 justify-center items-center w-1/12 mr-[15px]">
                                        <input
                                            className="text-[13px] bg-fieldbg w-full h-full pl-[15px] bg-[#616675] rounded"
                                            type="number"
                                            id="storyPoint"
                                            name="taskStoryPoint"
                                            min="0"
                                            max="10"
                                            value={
                                                editableSprintTask.taskStoryPoint ||
                                                ""
                                            }
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Tag */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[70px]">
                                        <label for="taskTag">
                                            <p className="text-[14px]">Tag</p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
                                        {/* <p className="pl-[5px] text-[12px]">UI</p> */}
                                        <select
                                            name="taskTag"
                                            id="taskTag"
                                            className="w-full bg-fieldbg text-[13px] h-[18px] pl-[5px] bg-[#616675] rounded"
                                            onChange={handleChange}
                                            type="select-multiple"
                                            multiple
                                        >
                                            <option value="Frontend">
                                                Frontend
                                            </option>
                                            <option value="Backend">
                                                Backend
                                            </option>
                                            <option value="API">API</option>
                                            <option value="Database">
                                                Database
                                            </option>
                                            <option value="Testing">
                                                Testing
                                            </option>
                                            <option value="UI">UI</option>
                                            <option value="Framework">
                                                Framework
                                            </option>
                                            <option value="UX">UX</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Priority */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[47px]">
                                        <label for="taskPriority">
                                            <p className="text-[14px]">
                                                Priority
                                            </p>
                                        </label>
                                    </div>

                                    <div className="bg-modalbg flex items-center mr-[10px] space-x-[10px]">
                                        <div className="flex items-center space-x-[2px] mr-[5px]">
                                            <input
                                                type="radio"
                                                name="taskPriority"
                                                value={1}
                                                onChange={handleChange}
                                                className={`${getPriorityBackgroundColor(colourBlindMode, 1)} w-full`}
                                            />
                                            <label for="priorityLow">
                                                <p className="text-[13px] pb-[1px]">
                                                    Low
                                                </p>
                                            </label>
                                        </div>
                                        <div className="flex items-center space-x-[2px]">
                                            <input
                                                type="radio"
                                                name="taskPriority"
                                                value={2}
                                                onChange={handleChange}
                                                className={`${getPriorityBackgroundColor(colourBlindMode, 2)} w-full`}
                                            />
                                            <label for="priorityMedium">
                                                <p className="text-[13px] pb-[1px]">
                                                    Medium
                                                </p>
                                            </label>
                                        </div>

                                        <div className="flex items-center space-x-[2px]">
                                            <input
                                                type="radio"
                                                name="taskPriority"
                                                value={3}
                                                onChange={handleChange}
                                                className={`${getPriorityBackgroundColor(colourBlindMode, 3)} w-full`}
                                            />
                                            <label for="priorityImportant">
                                                <p className="text-[13px] pb-[1px]">
                                                    Important
                                                </p>
                                            </label>
                                        </div>

                                        <div className="flex items-center space-x-[2px]">
                                            <input
                                                type="radio"
                                                name="taskPriority"
                                                value={4}
                                                onChange={handleChange}
                                                className={`${getPriorityBackgroundColor(colourBlindMode, 4)} w-full`}
                                            />
                                            <label for="priorityUrgent">
                                                <p className="text-[13px] pb-[1px]">
                                                    Urgent
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Description */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-baseline mr-[9px] pl-[21px] ">
                                        <label for="description">
                                            <p className="text-[14px]">
                                                Description
                                            </p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex shrink-10 items-baseline w-[100%] min-h-[64px]">
                                        <textarea
                                            className="relative text-[13px] w-[100%] bg-fieldbg ml-[15px]"
                                            name="taskDescription"
                                            value={
                                                editableSprintTask.taskDescription ||
                                                ""
                                            }
                                            onChange={handleChange}
                                            id="description"
                                            required
                                        ></textarea>
                                    </div>
                                </div>

                                {/* Status */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[53px]">
                                        <label for="taskStatus">
                                            <p className="text-[14px]">
                                                Status
                                            </p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
                                        <select
                                            name="taskStatus"
                                            id="statusTag"
                                            className="w-full bg-fieldbg text-[13px] bg-[#616675] rounded"
                                            onChange={handleChange}
                                        >
                                            <option value="NotStarted">
                                                Not Started
                                            </option>
                                            <option value="InProgress">
                                                In Progress
                                            </option>
                                            <option value="Completed">
                                                Completed
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                {/* Stage */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[56px]">
                                        <label for="stageTag">
                                            <p className="text-[14px]">Stage</p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
                                        <select
                                            name="taskStageTag"
                                            onChange={handleChange}
                                            id="stageTag"
                                            className="w-full bg-fieldbg text-[13px] bg-[#616675] rounded"
                                        >
                                            <option value="Planning">
                                                Planning
                                            </option>
                                            <option value="Development">
                                                Development
                                            </option>
                                            <option value="Testing">
                                                Testing
                                            </option>
                                            <option value="Intergration">
                                                Intergration
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                {/* Assignee */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[31px]">
                                        <label for="assignee">
                                            <p className="text-[14px]">
                                                Assignee
                                            </p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
                                        {/* replace with the database for the assignee */}
                                        <select
                                            name="taskAssignee"
                                            value={
                                                editableSprintTask.taskAssignee ||
                                                ""
                                            }
                                            onChange={handleChange}
                                            id="assignee"
                                            className="w-full bg-fieldbg text-[12px] bg-[#616675] rounded"
                                        >
                                            {userList.map((str) => (
                                                <option key={str} value={str}>
                                                    {str}
                                                </option>
                                            ))}
                                        
                                        </select>
                                    </div>
                                </div>

                                {/* Log Time Spent */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[7px]">
                                        <label for="logSpent">
                                            <p className="text-[12px]">
                                                Log Time Spent
                                            </p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex items-center mr-[6px] w-5/12 space-x-[15px]">
                                        <input
                                            className="pl-[20px] text-[12px] h-full bg-fieldbg w-3/12 bg-[#616675] rounded"
                                            type="number"
                                            id="logSpent"
                                            name="sprintLogTime"
                                            value={sprintCurrLogTime}
                                            onChange={handleSprintLogTimeChange}
                                            min="0"
                                            required
                                        />
                                        <p className="text-[12px]">Hours</p>
                                    </div>
                                    <div className="bg-fieldbg flex items-center mr-[15px] flex-auto">
                                        <input
                                            type="date"
                                            id="sprintStartDate"
                                            name="sprintStartDate"
                                            value={
                                                editableSprintTask.sprintStartDate
                                            }
                                            onChange={handleChange}
                                            required
                                            className="bg-[#616675] rounded w-full text-[12px] pl-[5px]"
                                        />
                                    </div>
                                </div>

                                {/* Total Log Time Spent */}
                                <div className="bg-modalbg flex mt-[10px]">
                                    <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[12px]">
                                        <label for="logTotal">
                                            <p className="text-[12px]">
                                                Total Log Time
                                            </p>
                                        </label>
                                    </div>
                                    <div className="bg-fieldbg flex shrink-10 items-center bg-[#616675] rounded mr-[10px] w-[11vh]">
                                        <p className="pl-[5px] text-[12px]">
                                            {
                                                editableSprintTask.sprintTotalLogTime
                                            }{" "}
                                            Hour
                                        </p>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex justify-around my-4 mx-[15vh]">
                                    <button
                                        type="submit"
                                        value="save"
                                        className="bg-[#616675] text-center px-3 py-1 rounded-lg text-xl"
                                    >
                                        SAVE
                                    </button>
                                    <button
                                        className="bg-[#616675] text-center px-3 py-1 rounded-lg text-xl"
                                        onClick={() => closeModal()}
                                    >
                                        CLOSE
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditSprintTask;
